<template>
  <div>
    <input
      :id="id"
      class="accent-primaryGreen bg-transparent cursor-pointer"
      type="checkbox"
      :name="name"
      :value="value"
    />
  </div>
</template>

<script>
export default {
  props: ["name", "value", "id"],
};
</script>

<style></style>
